/* OWNED BY THE FOUNDATION. */
import { Link, useLocation } from "react-router-dom";
import { useI18n, splitLocale } from "../lib/i18n";
import { QrButton } from "./Qr";

export function Header({ onQr }: { onQr: () => void }) {
  const { href, ui, locale } = useI18n();
  const { pathname } = useLocation();
  const { rest } = splitLocale(pathname);
  const other = locale === "cs" ? "en" : "cs";

  return (
    <header id="topbar">
      <Link className="mark" to={href("/")}>
        Create.<span className="red">Share.</span>Inspire.
      </Link>
      <nav>
        <Link to={href("/prehled")}>{ui("nav.overview")}</Link>
        <Link to={href("/p/teorie")}>{ui("nav.theory")}</Link>
        <Link to={href("/p/vyroba")}>{ui("nav.production")}</Link>
        <Link to={href("/p/prezentace")}>{ui("nav.slides")}</Link>
        <Link to={href("/p/prompty")}>{ui("nav.prompts")}</Link>
      </nav>
      <div className="spacer" />
      <QrButton onClick={onQr} />
      {/* The language switch keeps the reader where they are. Landing back on
          the home page after switching is the fastest way to lose someone. */}
      <Link className="lang" to={other === "cs" ? rest : `/en${rest === "/" ? "" : rest}`}>
        {other.toUpperCase()}
      </Link>
    </header>
  );
}
